<template>
    <modal
        name="product-added-to-basket-modal"
        width="90%"
        height="auto"
        scrollable
        @before-open="handleModalBeforeOpen"
    >
        <div class="p-5 sm:py-8 sm:px-10 border-t-8 border-primary">

            <div class="md:flex justify-between">
                <div class="flex">
                    <CheckMarkCircleIcon class="h-16 text-green-light mr-8" />
                    <div>
                        <div class="text-xl font-semibold tracking-wide mr-5">
                            Added to Basket
                        </div>
                        <div class="leading-tight">
                            {{ product.name }}
                        </div>
                    </div>
                </div>
                <div class="md:flex items-center self-start">
                    <div class="md:mr-10">
                        <Button
                            text="Checkout"
                            class="w-full text-center my-10 md:my-0"
                            @click="$router.push('/checkout')"
                        />
                    </div>
                    <div class="flex align-items-center justify-center">
                        <CloseIcon
                            class="close-icon mr-3"
                            @click="closeModal"
                        /> <span class="md:hidden">Continue shopping</span>
                    </div>

                </div>
            </div>

            <div class="mt-8">
                <h4 class="mb-5 tracking-wide uppercase">
                    Make it extra special
                </h4>
                <ProductAddOns :product="product" />
            </div>

            <div class="mt-8">
                <h4 class="mb-5 tracking-wide uppercase">
                    You may also like
                </h4>
                <YouMayAlsoLike
                    :products="product.cross_sells"
                    :product="product"
                />
            </div>

        </div>
    </modal>
</template>

<script>
import CheckMarkCircleIcon from '~/static/fonts/LineIcons/checkmark-circle.svg';
import CloseIcon from '~/static/fonts/LineIcons/close.svg';
import YouMayAlsoLike from '~/components/YouMayAlsoLike';
import Button from '~/components/Button';
/* eslint-disable-next-line */
import tailwindConfig from '@/tailwind.config.js';
import ProductAddOns from '@/components/ProductAddOns.vue';

export default {

    components: {
        ProductAddOns,
        CheckMarkCircleIcon,
        CloseIcon,
        YouMayAlsoLike,
        Button,
    },

    data() {
        return {
            product: {},
        };
    },

    methods: {
        handleModalBeforeOpen({ params }) {
            this.product = params.product;

            this.$bus.$emit('basket-add', {
                product: this.product,
            });

            this.$ga.ecommerce.addProduct({
                id: this.product.sku,
                name: this.product.name,
                category: this.product.category,
                price: parseFloat(this.product.price),
                quantity: 1,
            });
            this.$ga.ecommerce.setAction('add');
            this.$ga.event('product', 'click', 'buy', parseInt(this.product.price, 10));
        },
        closeModal() {
            this.$modal.hide('product-added-to-basket-modal');
        },
    },

};
</script>

<style lang="scss" scoped>
.close-icon {
    @apply h-5 cursor-pointer transition-fast;
    box-sizing: content-box;
    &:hover {
        @apply opacity-50;
    }
}
</style>
